export default function NotFound() {
  return (
    <section
      style={{
        padding: "120px 24px",
        textAlign: "center",
        backgroundColor: "var(--bg)",
        color: "var(--muted)"
      }}
    >
      there's no page here.. how did you even do this? nice
    </section>
  )
}